import { z } from "zod";

import { EMAIL_MESSAGE, REQUIRED_MESSAGE } from "@/utils";

export const teamFormSchema = z.object({
  data: z.object({
    firstName: z.string().min(3, { message: REQUIRED_MESSAGE }),
    lastName: z.string().min(3, { message: REQUIRED_MESSAGE }),
    optionCpfCnpj: z.enum(["cpf", "cnpj"], { message: REQUIRED_MESSAGE }),
    document: z
      .string().min(1, { message: REQUIRED_MESSAGE })
      .regex(/^[0-9]{11,14}$/, { message: "Documento inválido" }),
    birthDate: z.coerce.date({ message: REQUIRED_MESSAGE }),
    phone: z.string().regex(/^\d{10,11}$/, { message: "Telefone inválido" }),
    zipcode: z.string().min(8, { message: REQUIRED_MESSAGE }).regex(/^\d{8}$/, { message: "CEP inválido" }),
    state: z.string().min(2, { message: REQUIRED_MESSAGE }),
    city: z.string().min(2, { message: REQUIRED_MESSAGE }),
    neighborhood: z.string(),
    street: z.string().min(2, { message: REQUIRED_MESSAGE }),
    number: z.string().min(1, { message: REQUIRED_MESSAGE }),
    complement: z.string().optional(),
  }),

  login: z.object({
    email: z.string({ message: EMAIL_MESSAGE }).email(),
    password: z.string({ message: REQUIRED_MESSAGE }).min(6),
  }),

  permissions: z.object({
    accessLevel: z.string().min(1, "Selecione um nível de acesso"),
    selectedPermissions: z.array(z.string()).default([]),
  }),
});

export type TUserTeamFormData = z.infer<typeof teamFormSchema>;

export const teamFormUpdateSchema = teamFormSchema.extend({
  login: z.object({
    email: z.string({ message: EMAIL_MESSAGE }).email(),
    password: z.union([z.literal(""), z.string().min(6)]).optional(),
  }),
});
